import RestAPI from 'components/Common/restApi';

export default class BetaEstimatesAPI {
  static getEstimates(params) {
    return RestAPI.getWithQueryString('/beta/estimates', params);
  }

  static markLost(uuid) {
    return RestAPI.post(`/beta/estimates/${uuid}/mark_lost/`);
  }

  static markWon(estimateUuid, optionUuid) {
    return RestAPI.post(`/beta/estimates/${estimateUuid}/options/${optionUuid}/mark_won/`);
  }

  static copyToJob(uuid) {
    return RestAPI.post(`/beta/estimates/${uuid}/copy_to_job/`);
  }

  static getMetrics() {
    return RestAPI.get('/beta/estimates/metrics');
  }

  static schedule(estimateUuid, optionUuid, params) {
    return RestAPI.postWithFormData(`/beta/estimates/${estimateUuid}/options/${optionUuid}/schedule/`, params);
  }

  static emailCustomer(estimateUuid, params) {
    return RestAPI.postWithFormData(`/beta/estimates/${estimateUuid}/email_customer`, params);
  }

  static textCustomer(estimateUuid, params) {
    return RestAPI.postWithFormData(`/beta/estimates/${estimateUuid}/text_customer`, params);
  }
}
